import { useEffect, useRef, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { InactivityBackdrop, InactivityCounter, InactivityMessage, InactivityWrapper } from './Inactivity.styles'

const Inactivity = ({ t }) => {
  const [counter, setCounter] = useState(10)
  const intervalRef = useRef(null)
  const navigate = useNavigate()

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCounter(counter => {
        const res = counter - 1

        if (res === 0) {
          clearInterval(intervalRef.current)
          navigate('/')
        }
        return res
      })
    }, 1000)

    return () => {
      clearInterval(intervalRef.current)
      setCounter(10)
    }
  }, [])

  return (
    <InactivityWrapper>
      <InactivityBackdrop />
      <InactivityCounter>{counter}</InactivityCounter>
      <InactivityMessage>{t('inactivityMessage')}</InactivityMessage>
    </InactivityWrapper>
  )
}

export default withTranslation()(Inactivity)
